























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class TransactionSummary extends Vue {

  // 商品分析表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public projectItem: Common.ProjectItem = null;
  public segment: Common.Segment = null;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public sort: number = 0;
  public itemCategory: number = null;
  public summaryCategory1: number = null;
  public summaryCategory2: number = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public includeProspect: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){       
      var query: Common.TransactionSummaryReportTemplateQuery = new Common.TransactionSummaryReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date().getCalendarDate();
    this.startDate = null;
    this.endDate = null;
    (this.$refs.TransactionSummaryDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.TransactionSummaryReportQuery = new Common.TransactionSummaryReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.projectItem = this.projectItem;
    query.segment = this.segment;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.sort = this.sort;
    query.itemCategory = this.itemCategory;
    if (this.summaryCategory1 == null) query.summaryCategory1 = 0;
    else query.summaryCategory1 = this.summaryCategory1;
    if (this.summaryCategory2 == null) query.summaryCategory2 = 0;
    else query.summaryCategory2 = this.summaryCategory2;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.includeProspect = this.includeProspect;
    query.onExcelExport = this.onExcelExport;

    this.$api.download(query);
  }
}
